module.exports = __webpack_public_path__ + "49471e3c27c0db5ad966532bd9059f13.svg";